
import Vue from 'vue';
import { mapState } from 'vuex';
import { ROUTER } from '@/router/constants';
import { RunnitsAndRunnitNodeDefsBindingsMixin } from '@/mixins';
import { isRouteRunnitSideNavPage } from '@/router/utils';

export default Vue.extend({
	name: 'Runnits',
	metaInfo () {
		return {
			titleTemplate: '%s | Runnit | RunDiffusion',
		};
	},
	mixins: [
		RunnitsAndRunnitNodeDefsBindingsMixin,
	],
	computed: {
		...mapState([
			'toolbar',
		]),
		shouldRemoveSideMargins () {
			return [
				ROUTER.RUNNITS_BOARD,
				// Boards v2's list paints its own background edge to edge
				ROUTER.RUNNIT_BOARDS_V2_PAGE,
			].includes(this.$route.name);
		},
	},
	methods: {
		isRouteRunnitSideNavPage,
	},
});
